import { hash, concat } from '@ember/helper';
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import { WithBoundArgs } from '@glint/template';
import { ModelListItem } from 'core/components/model-list';
import Protocol from 'core/models/protocol';
import PauseOkChimioButton from './protocol-section/pause-ok-chimio-button/index';
import PauseProtocolSection from './protocol-section/pause-protocol-section/index';
import templateOnly from '@ember/component/template-only';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const TrashItem = setComponentTemplate(precompileTemplate("\n  <i class=\"trash icon opacity-40\" role=\"button\" {{on \"click\" @item.destroy}}></i>\n", {
  strictMode: true,
  scope: () => ({
    on
  })
}), templateOnly(undefined, "protocol-section:TrashItem"));
const TreatmentHistoryProtocolUtilsProtocolSectionComponent = setComponentTemplate(precompileTemplate("\n    <div class=\"ui segment\" data-test-protocol-section={{@protocolModel.protocol}}>\n      <div>\n        <h3 class=\"ui dividing header\">{{t (concat \"treatment-protocol.\" @protocolModel.protocol)}}</h3>\n        <div class=\"absolute right-0 top-0 mr-2 mt-4\">\n          {{yield (hash TrashItem=(component TrashItem item=@item) PauseOkChimioButton=(component PauseOkChimioButton protocolModel=@protocolModel)) to=\"headerActions\"}}\n        </div>\n      </div>\n      <div>\n        {{#if @protocolModel.isPaused}}\n          <div class=\"placeholder-label mb-2 p-1\" data-test-current-treatment-is-paused-message>\n            Le traitement est actuellement en pause. Veuillez entrer la\n            prochaine date de cure pour reprendre.\n          </div>\n        {{/if}}\n\n        {{yield (hash PauseProtocolSection=PauseProtocolSection) to=\"content\"}}\n\n      </div>\n    </div>\n  ", {
  strictMode: true,
  scope: () => ({
    t,
    concat,
    hash,
    TrashItem,
    PauseOkChimioButton,
    PauseProtocolSection
  })
}), templateOnly(undefined, "protocol-section:TreatmentHistoryProtocolUtilsProtocolSectionComponent"));
export default TreatmentHistoryProtocolUtilsProtocolSectionComponent;